import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import { isMoment } from 'moment';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import ModalYesNo from './ModalYesNo'

export class ShortedProducts extends Component {
    static displayName = ShortedProducts.name;
    constructor(props) {
        super(props);
        this.state = {
            selectedPick: props.location.state.selectedPick, pickOptions: props.location.state.pickOptions, shortedProducts: [], toggleShortedProductList: true,
            alternateLocationLocations: [], alternatePacks: [], selectedShortedProduct: null,
            showEndPickModal: false

        };
        this.history = props.history;
    }
    componentDidMount() {
        if (typeof this.props.location.state.backFromPickLocation !== 'undefined') {
            this.getAlternateLocations(this.props.location.state.backPickData)
        }
        else {
            this.getShortedProducts();
        }
        
    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }
    render() {
        return (
            <>
                <h5>Shorted Products</h5>
                <h6>Pick: {this.state.selectedPick.pickNumber}</h6>
                { this.state.toggleShortedProductList && <>
                    <div>Products List</div>
                    {this.state.loading && <em className="mt-1"> Loading alternate location...</em>}
                    <Table responsive>
                        <thead>
                            <tr>
                                <td><b>Code</b></td>
                                <td><b>Description</b></td>
                                <td><b>Bal</b></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.shortedProducts.map((element, index) => (
                                <tr key={element.product_id}>
                                    <td>{element.code}</td>
                                    <td>{element.description}</td>
                                    <td>{element.balance}</td>
                                    <td><Button className="btn btn-success" onClick={() => { this.getAlternateLocations(element) }}>Select</Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className="text-center">
                        <Button variant="success" className="m-3" onClick={() => { this.goto('ActivePicks', { nameCode: this.state.selectedPick.nameCode }) }}>Back</Button>
                        <Button variant="success" className="m-3" onClick={() => { this.setState({ showEndPickModal: true }) }}>End Picking</Button>
                    </div></>}
                { !this.state.toggleShortedProductList && this.state.selectedShortedProduct !== null && <>
                    <div>
                        <div className="m-3">Product: {this.state.selectedShortedProduct.description}</div>
                        <div className="m-3">Qty    :{this.state.selectedShortedProduct.balance}</div>
                    </div>
                    <div>Alternate Pick Locations</div>
                    {this.state.loading && <em className="mt-1"> Loading alternate location...</em> }
                    {!this.state.loading && <Table responsive>
                        <thead>
                            <tr>
                                <td><b>Location</b></td>
                                <td><b>MHE Required</b></td>
                                <td><b>Qty Avl.</b></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.alternateLocationLocations.map((element, index) => (
                                <tr key={element.locationBarcode}>
                                    <td>{element.locationBarcode}</td>
                                    <td>{element.pickmethod}</td>
                                    <td>{element.quantityAvailable}</td>
                                    <td><Button onClick={() => { this.gotoPickLocationScreen(element) }}>Pick</Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>}
                    <div className="text-center">
                        <Button variant="success" className="m-3" onClick={() => { this.setState({ toggleShortedProductList: true }); this.getShortedProducts(); }}>Back</Button>
                    </div>
                </>}
                <ModalYesNo title="Confirm" show={this.state.showEndPickModal} message={this.state.pickOptions.PreventShortPick ? "WARNING: ALL short-picked locations will now be marked as Stop Pick. Do you want to continue?" : "WARNING: ALL short-picked locations will now be marked as Complete. Do you want to continue?"} onClickYes={(e) => { this.endPickingShortedProducts() }} onClickNo={() => { this.setState({ showEndPickModal: false }); }}></ModalYesNo>

            </>
        );
    }


    async getShortedProducts() {
        this.setState({ loading: true });
        fetch(`api/PaperlessPicking/GetShortedProductsByPick?pickNumber=${this.state.selectedPick.pickNumber}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, shortedProducts: result.data, alertMessage: "" });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            })

    };

    async getAlternateLocations(shortedProduct) {
        this.setState({ loading: true, toggleShortedProductList: false, selectedShortedProduct: shortedProduct, alternateLocationLocations: [] });
        const nextPickRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                pickNumber: this.state.selectedPick.pickNumber,
                shortedProductId: shortedProduct.product_id,
                PickOptions: this.state.pickOptions
            })
        };
        fetch('api/PaperlessPicking/GetAlternativeLocationsByProductId', nextPickRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alternateLocationLocations: result.data.alternatePickLocations, alternatePacks: result.data.alternatePacks, alertMessage: "" });

                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            })
    }




    async endPickingShortedProducts() {
        this.setState({ loading: true, showEndPickModal: false });
        const endPickRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                pickNumber: this.state.selectedPick.pickNumber,
                shortedProducts: this.state.shortedProducts,
                stageID: this.state.selectedPick.stageID,
                pickOptions: this.state.pickOptions,
                userID: MyGlobal.user
            })
        };
        fetch('api/PaperlessPicking/EndPickingForShortedProducts', endPickRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                        this.goto("ChoosePick", {});

                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            })
    }

    gotoPickLocationScreen(pickData) {
        pickData.travelTimeStart = new Date();
        this.goto('PickLocation', { pickNumber: this.state.selectedPick.pickNumber, mheId: pickData.pick_method_id, rowName: pickData.row, pickDirection: 1, pickOptions: this.state.pickOptions, pickData: pickData, isPickingShorts: true, nameCode: this.state.selectedPick.nameCode, selectedPick: this.state.selectedPick  });
    }
}
export default ShortedProducts;

